import React from 'react';
import type { ILandingPageRenderData } from '@share/common-types';
import { LayoutType } from '@share/common-types';
import { LayoutImmersive } from './layout-immersive';
import { LayoutStory } from './layout-story';
import { LayoutShowcase } from './layout-showcase';

function pickLayout(data: ILandingPageRenderData): React.ReactElement {
  switch (data.layoutType) {
    case LayoutType.StoryDriven:
      return <LayoutStory data={data} />;
    case LayoutType.FeatureShowcase:
      return <LayoutShowcase data={data} />;
    case LayoutType.ImmersiveGallery:
    default:
      return <LayoutImmersive data={data} />;
  }
}

export function LandingPageRenderer({ data }: { data: ILandingPageRenderData }) {
  return pickLayout(data);
}
